import { QueueStatus } from '@config/constants/enum';
import { ActionIcon, Flex } from '@mantine/core';
import {
	IconEye,
	IconFileDownload,
	IconSend,
} from '@tabler/icons-react';
import { MouseEventHandler } from 'react';

export const CellOffsetActions = (props: {
	onShow: MouseEventHandler<HTMLButtonElement>;
	onDownload: MouseEventHandler<HTMLButtonElement>;
	onSend: MouseEventHandler<HTMLButtonElement>;
	data: any;
}) => {
	const { onShow, onDownload, onSend } = props;
	return (
		<Flex gap="10px">
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="light"
				radius={'xl'}
				color="var(--mantine-color-igluGreen-9)"
				onClick={onShow}
				disabled={
					props.data.status !== QueueStatus.SUCCESS
				}
			>
				<IconEye size="18px" stroke={1.5} />
			</ActionIcon>
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="light"
				radius={'xl'}
				color="var(--mantine-color-igluBlue-9)"
				onClick={onDownload}
				disabled={
					props.data.status !== QueueStatus.SUCCESS
				}
			>
				<IconFileDownload size="18px" stroke={1.5} />
			</ActionIcon>
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="light"
				radius={'xl'}
				color="var(--mantine-color-igluYellow-9)"
				onClick={onSend}
				disabled={
					props.data.status !== QueueStatus.SUCCESS
				}
			>
				<IconSend size="18px" stroke={1.5} />
			</ActionIcon>
		</Flex>
	);
};
